import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationEnd,
  Event as RouterEvent,
  NavigationStart,
  NavigationCancel,
  NavigationError,
  ActivatedRoute,
} from "@angular/router";
import { filter, map } from 'rxjs/operators';
import { SharedService } from './services/shared.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  loading: boolean = false;
  exp:any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private sharedService: SharedService,
    private authService: AuthService
  ){
    this.titleChangeRouteListener();
  }
  ngOnInit() {
    this.sharedService.setLoading$.subscribe((isLoading: boolean) => {
      this.loading = isLoading;
    });
    this.sessionConfig();
  }

  sessionConfig(): void {
    const timeSet = 30 * 60 * 1000;
    window.onblur = () => {
      this.exp = setTimeout(() => {
      this.authService.logout();
      this.authService.clearLocalStorage();
      }, timeSet);
    }
    window.onfocus = () => {
      clearTimeout(this.exp);
    }
  }

  titleChangeRouteListener() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data["title"]) {
              return child.snapshot.data["title"];
            } else {
              return null;
            }
          }
          return null;
        })
      )
      .subscribe((data: any) => {
        if (data) {
          const title = data.replace(/[{,}]/g, "");
          this.titleService.setTitle(title + " - ArchiveMyRia");
        } else this.titleService.setTitle("ArchiveMyRia");
      });
  }
}
